import React from 'react';
import { Sun, Battery } from 'lucide-react';
import { SystemPlanningConfig } from '../../types/systemPlanning';

interface Props {
  config: SystemPlanningConfig;
  updateConfig: (partial: Partial<SystemPlanningConfig>) => void;
}

export function SolarBatteryConfig({ config, updateConfig }: Props) {
  return (
    <div className="space-y-3">
      <p className="text-xs text-gray-400">Enter your currently installed capacity</p>

      <div className="flex items-center gap-3">
        <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 w-32">
          <Sun size={14} className="text-yellow-500" />
          Solar (kW)
        </label>
        <input
          type="number"
          min={0}
          max={50}
          step={0.5}
          value={config.currentSolarKw}
          onChange={e => updateConfig({ currentSolarKw: Math.max(0, Math.min(50, Number(e.target.value))) })}
          className="w-24 text-sm border border-gray-200 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-yellow-500"
        />
        <span className="text-xs text-gray-400">
          ≈ {Math.ceil((config.currentSolarKw * 1000) / 400)} panels
        </span>
      </div>

      <div className="flex items-center gap-3">
        <label className="flex items-center gap-1.5 text-sm font-medium text-gray-700 w-32">
          <Battery size={14} className="text-blue-500" />
          Battery (kWh)
        </label>
        <input
          type="number"
          min={0}
          max={200}
          step={1}
          value={config.batteryStorageKwh}
          onChange={e => updateConfig({ batteryStorageKwh: Math.max(0, Math.min(200, Number(e.target.value))) })}
          className="w-24 text-sm border border-gray-200 rounded px-2 py-1 focus:outline-none focus:ring-1 focus:ring-blue-500"
        />
      </div>
    </div>
  );
}
